<div class="modal-header">
  <h4 class="modal-title">{{ getTitle() }}</h4>
  <button type="button" class="btn btn-default btn-close" id="closeButton" aria-label="Close" (click)="closeModal(false)"></button>
</div>
<div class="modal-body">
  @if (canPrint()) {
    <div class="printer-selector">
      <ng-container *appIfNot2025>
        <dx-button-group [items]="((canPrintWithRfidPrinter() && canPrintWithBarcodePrinter()) ? [ 'rfid', 'barcode' ] : (canPrintWithRfidPrinter() ? [ 'rfid' ] : (canPrintWithBarcodePrinter() ? [ 'barcode' ] : [])))">
          <button class="btn btn-default" *dxTemplate="let selectedPrinterType of 'item'"
            [ngClass]="{ 'active': selectedPrinter === selectedPrinterType }"
            [disabled]="processingPrint" (click)="changePrinter(selectedPrinterType)">
            {{ (selectedPrinterType === 'rfid' ? 'App_RFID' : 'App_Barcode') | translate }}
          </button>
        </dx-button-group>
      </ng-container>
      <ng-container *appIf2025>
        <dx-button-group [items]="canPrintWithBarcodePrinter() ? [ 'barcode' ] : []">
          <button class="btn btn-default active" *dxTemplate="let selectedPrinterType of 'item'"
            [disabled]="processingPrint" (click)="changePrinter(selectedPrinterType)">
            {{ (selectedPrinterType === 'rfid' ? 'App_RFID' : 'App_Barcode') | translate }}
          </button>
        </dx-button-group>
      </ng-container>
    </div>
  }
  @if (selectedPrinter == 'rfid') {
    <div>
      <key-note type="danger"><i class="fa fa-exclamation-triangle"></i><strong>&nbsp;{{ 'App_DeprecatedRfidLabels' | translate }}</strong></key-note>
    </div>
  }
  @if (displayNotification$ | async; as displayNotification) {
    <app-print-notification [show]="displayNotification" [singleOrderLine]="hasSingleSelectedOrderLine()"></app-print-notification>
  }
  @if (generatingSerials) {
    <app-serials-generation-progress
      [orderId]="serialsGenerationData.orderId"
      [productId]="serialsGenerationData.productId"
      [labelSelectorStatus]="serialsGenerationData.labelSelectorStatus"
      [startTimestamp]="serialsGenerationData.startTimestamp"
      (generationCompleted)="onGenerationCompleted($event)">
    </app-serials-generation-progress>
  }
  @if (isProductModal() && !generatingSerials) {
    <app-product-labels-selector
      [inventory]="toPrint"
      [usingRfid]="isRfidPrinterSelected()"
      [hideSizesWithoutGtinOrSku]="hideSizesWithoutGtinOrSku"
      (onChange)="updateLabelsToPrint($event)"
      (onLoad)="updateLabelsToPrint($event)"
      (onSet)="updateLabelsToPrint($event)">
    </app-product-labels-selector>
  }
  @if (canIncludeAlreadyPrinted() && !generatingSerials) {
    <div id="includeAlreadyPrintedOption">
      <key-checkbox id="includeAlreadyPrinted"
        [value]="includeAlreadyPrinted"
        [disabled]="processingPrint"
        (valueChanged)="toggleIncludeAlreadyPrinted($event)">
        {{ 'RGo_PrintLabelsDialog_IncludeAlreadyPrinted' | translate }}
      </key-checkbox>
    </div>
  }
  @if (mustShowAllReceivedAlreadyPrintedNote() && !generatingSerials) {
    <div id="allReceivedAlreadyPrintedNote">
      <key-note type="info">{{ 'RGo_PrintLabelsDialog_AllReceivedAlreadyPrinted' | translate }}</key-note>
    </div>
  }
  @if (isPurchaseOrderModal() && !generatingSerials) {
    <app-delivery-labels-selector
      [orderType]="subType"
      [orderLines]="toPrint"
      [usingRfid]="isRfidPrinterSelected()"
      [includeAlreadyPrinted]="isIncludingAlreadyPrinted()"
      [hideSizesWithoutGtinOrSku]="hideSizesWithoutGtinOrSku"
      (onChange)="updateLabelsToPrint($event)"
      (onLoad)="updateLabelsToPrint($event)"
      (onSet)="updateLabelsToPrint($event)">
    </app-delivery-labels-selector>
  }
  <div class="print-summary">
    <div><span class="fw-bold">{{ 'App_NumberOfLabels' | translate }}</span>: {{ totalLabelsToPrint$ | async }}</div>
    @if (printerSummary$ | async; as printerSummary) {
      <div><span class="fw-bold">{{ 'App_PrintingTo' | translate }}</span>: {{ printerSummary.printerName }}</div>
      <div>
        <span class="fw-bold">{{ 'App_LastKnownStatus' | translate }}</span>:
        <span class="printer-status-summary">
          <span class="printer-status-summary-item">
            <span class="printer-status-summary-item-title">{{ 'App_PrintAgent' | translate }}</span>
            @if (printerSummary.printAgentStatus === 'A') {
              <span class="badge bg-success">{{ 'App_Online' | translate }}</span>
            }
            @if (printerSummary.printAgentStatus === 'D') {
              <span class="badge bg-default">{{ 'App_Offline' | translate }}</span>
            }
          </span>
          <span class="printer-status-summary-item">
            <span class="printer-status-summary-item-title">{{ 'App_Printer' | translate }}</span>
            @if (printerSummary.printAgentStatus === 'A' && printerSummary.printerStatus === 'A') {
              <span class="badge bg-success">{{ 'App_Online' | translate }}</span>
            }
            @if (printerSummary.printAgentStatus === 'A' && printerSummary.printerStatus === 'D') {
              <span class="badge bg-default">{{ 'App_Offline' | translate }}</span>
            }
            @if (printerSummary.printAgentStatus === 'D') {
              <span class="badge bg-default">{{ 'App_Unknown' | translate }}</span>
            }
          </span>
        </span>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  @if (!isBarcodePrinterSetUp() || !isRfidPrinterSetUp()) {
    <div class="printer-notes">
      @if (!isBarcodePrinterSetUp()) {
        <span>{{ 'App_SetBarcodePrinterToPrintBarcodeLabels' | translate }}</span>
      }
      @if (!isRfidPrinterSetUp()) {
        <span>{{ 'App_SetRfidPrinterToPrintRfidLabels' | translate }}</span>
      }
    </div>
  }
  <button class="btn btn-primary" type="button" id="printButton"
    [disabled]="!canPrint() || processingPrint || getTotalLabelsToPrint() <= 0"
    (click)="print()">
    {{ 'App_Print' | translate }}
  </button>
  <button class="btn btn-default" type="button" id="cancelButton" (click)="closeModal(false)">{{ 'App_Cancel' | translate }}</button>
</div>

